import client from '../httpClient';

const sendmailGetCountsApi = (params) => {
  return client.get('/send-mails/bukken/counts', { params, isShowMessage: true });
};

export default sendmailGetCountsApi;
